import { FilterOutlined, PlusOutlined } from "@ant-design/icons";
import { DeleteOutlined, EditOutlined, MoreOutlined } from "@ant-design/icons";
import { Breadcrumb, Col, Divider, Dropdown, Flex, Form, Modal, Row, Space, Switch, Button } from "antd";
import { CardContainer } from "components/elements";
import { MainLayout } from "components/layouts";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import schema, {
  initialValues as INITIAL_VALUES,
} from "../schemas/accountCategorySchema";
import { useState } from "react";
import styles from "../styles/AccountCategoryList.module.css";
import { Formik } from "formik";
import { Input, Select } from "components/form";
import { useSelector } from "react-redux";
import AccountCategoryFilter from "./AccountCategoryFilter";
import TableAntd from "components/elements/Table/Table";
import { ReactComponent as CreateIcon } from "../../../assets/icon/createIcon.svg";
import { ReactComponent as FilterIcon } from "../../../assets/icon/filterIcon.svg";

const AccountCategoryList = ({
  initialValues = {},
  accountCategoryList = [],
  isLoading = false,
  isModalOpen = false,
  pagination = {},
  onSearch = () => { },
  onStatus = () => { },
  onDelete = () => { },
  onChange = () => { },
  onCreate = () => { },
  onEdit = () => { },
  onCancel = () => { },
  onSubmit = () => { },
  amountIncomeDeductionOptions = [],
}) => {
  const { t, i18n } = useTranslation();
  const { roles } = useSelector((state) => state.company);
  const [useFilter, setUseFilter] = useState(false);
  const columns = [
    {
      title: (
        <div className="text-table">{t("common.index")}</div>
      ),

      dataIndex: "id",
      key: "id",
      width: "10%",
      align: "center",
      render: (text, record, index) => index + 1
    },
    {
      title: <div className="text-table">{t("account_category_list.label.Account_Category_name")}</div>,
      dataIndex: "accountCategoryName",
      key: "accountCategoryName",
      width: "20%",
      sorter: (a, b) => a.commonTypeName.length - b.commonTypeName.length,
      render: (_, record) => {
        if (i18n.language === "en") {
          return record.commonTypeNameEn;
        }
        return record.commonTypeName;
      },
    },
    {
      title: <div className="text-table">{t("account_category_list.label.last_modified")}</div>,
      dataIndex: "lastModified",
      key: "lastModified",
      width: "10%",
      sorter: {
        compare: (a, b) => null,
        multiple: 2,
      },
      render: (_, record) => {
        const { createBy, updateBy, createDate, updateDate } = record;
        let lastModified = updateBy ? updateBy : createBy
        const name = i18n.language === "en" && lastModified.nameEn
          ? lastModified.nameEn
          : lastModified.name;
        return (
          <>
            {name}
            <br />
            {(createDate || updateDate)
              ? dayjs(updateDate ?? createDate).format("DD/MM/YYYY HH:mm")
              : "-"}
          </>
        );
      },
    },
    {
      title: (
        <div className="text-table">{t("year_accumulate_list.label.status")}</div>
      ),
      dataIndex: "statusFlag",
      key: "statusFlag",
      align: "center",
      width: "10%",
      render: (text, record) => (
        <Switch
          checked={text === "ACTIVE"}
          onChange={(checked) => { onStatus(checked, record); console.log("ddddddd", record.values); }}
          disabled={roles.includes("UPDATE_MASTER_DATA_LIST|ACCOUNT_CATEGORY") ? false : true}
        />
      ),
    },
    roles.includes("UPDATE_MASTER_DATA_LIST|ACCOUNT_CATEGORY",
      "DELETE_MASTER_DATA_LIST|ACCOUNT_CATEGORY") ? {
      title: <div className="text-table">{t("action.action")}</div>,
      key: "action",
      width: "10%",
      align: "center",
      fixed: "right",
      render: (_, record) => (
        <Space size="middle">
          <Dropdown
            menu={{
              items: [
                roles.includes("UPDATE_MASTER_DATA_LIST|ACCOUNT_CATEGORY") && {
                  key: "1",
                  onClick: () => onEdit(record),
                  label: `${t("action.edit")}`,
                  icon: (
                    <EditOutlined style={{ fontSize: "18px", color: "gray" }} />
                  ),
                },
                roles.includes("DELETE_MASTER_DATA_LIST|ACCOUNT_CATEGORY") && record?.statusFlag !== "ACTIVE" && {
                  key: "2",
                  onClick: () => onDelete(record),
                  label: `${t("action.delete")}`,
                  icon: (
                    <DeleteOutlined
                      style={{ fontSize: "18px", color: "gray" }}
                    />
                  ),
                },
              ],
            }}
          >
            <MoreOutlined style={{ fontSize: "25px", color: "gray" }} />
          </Dropdown>
        </Space>
      ),
    } : {},
  ];


  return (
    <MainLayout>
      <Modal
        title={
          initialValues.accumulateId ? t("common.edit") : t("common.create")
        }
        open={isModalOpen}
        closable={false}
        onOk={() => { }}
        onCancel={() => {
          const cancelBtn = document.getElementById(
            "year_accumulate_cancelBtn"
          );
          if (cancelBtn) {
            cancelBtn.click();
          } else {
            onCancel();
          }
        }}
        width="511px"
        footer={null}
        maskClosable={false}
      >
        <Formik
          enableReinitialize
          initialValues={{ ...INITIAL_VALUES, ...initialValues }}
          onSubmit={onSubmit}
          validationSchema={schema}
        >
          {({ values = {}, submitForm, setFieldValue, resetForm }) => {
            return (
              <Form onFinish={submitForm}>
                <Space direction="vertical" size={6} style={{ width: "100%" }}>
                  <Divider />
                  <Row gutter={[24, 10]}>
                    <Col span={24}>
                      <Input
                        required
                        name="commonTypeName"
                        label={
                          t("account_category_list.label.Account_Category_name") + t('th')
                        }
                        placeholder={t("account_category_list.label.Account_Category_name") + t('th')}
                        size="large"
                        regex={/^[\u0E00-\u0E7F0-9\s\p{P}\p{S}]*$/u}
                        formRegex={true}
                      />
                    </Col>
                    <Col span={24}>
                      <Input
                        required
                        name="commonTypeNameEn"
                        placeholder={t("account_category_list.label.Account_Category_name") + t('en')}
                        size="large"
                        label={
                          t("account_category_list.label.Account_Category_name") + t('en')
                        }
                        regex={/^[๐-๙a-zA-Z0-9\s\p{P}\p{S}]*$/u}
                        formRegex={true}
                      />
                    </Col>
                  </Row>
                  <div style={{ height: 12 }} />
                  <Row justify="end">
                    <Space direction="horizontal" size={12}>
                      <Button
                        id="year_accumulate_cancelBtn"
                        type="default"
                        onClick={() => {
                          resetForm();
                          onCancel();
                        }}
                        style={{ height: "40px", borderRadius: "8px" }}
                      >
                        {t("common.cancel").toUpperCase()}
                      </Button>
                      <Button htmlType="submit" type="primary" style={{ height: "40px", borderRadius: "8px", backgroundColor: "var(--button-color)" }}>
                        {t("common.submit").toUpperCase()}
                      </Button>
                    </Space>
                  </Row>
                </Space>
              </Form>
            );
          }}
        </Formik>
      </Modal>

      <Space className={styles.container} direction="vertical" size={24}>
        <Flex vertical>
          <Breadcrumb items={[
            { title: t("home.header"), href: "/" },
            { title: t("masterdata.header"), href: "" },
            { title: t("account_category_list.header") },
          ]} />
          <h2>{t("account_category_list.header")}</h2>
        </Flex>
        <Row justify="end">
          <Space direction="horizontal" size={24}>
            <Button type="default" onClick={() => { setUseFilter(!useFilter) }} style={{ padding: "8px 16px", height: "44px", borderRadius: "8px" }}>
              <Flex align="center" justify="center" gap={8}>
                <FilterIcon />
                <span style={{ color: "#667085" }}>{t('common.filter')}</span>
              </Flex>
            </Button>
            {/* <a href="/employee/create"> */}
            {
              roles.includes("CREATE_MASTER_DATA_LIST|ACCOUNT_CATEGORY") && <Button onClick={(e) => {
                onCreate();
              }} style={{ width: "max-content", height: "44px", borderRadius: "8px", backgroundColor: "var(--button-color)", padding: "8px 16px" }}
                type="primary"
              >
                <Flex align="center" justify="center" gap={8}>
                  <CreateIcon />
                  <span>{t('my_document.create')}</span>
                </Flex>
              </Button>
            }

            {/* </a> */}
          </Space>
        </Row> {useFilter && (
          <CardContainer width="100%" height="fit-content">
            <AccountCategoryFilter
              // organizationUnderOptions={organizationUnderOptions}
              // shiftDropDown={shiftDropDown}
              // modifiedPositionOptions={modifiedPositionOptions}
              // workInLocationOptions={workInLocationOptions}
              // durationOptions={durationOptions}
              // supervisorOptions={supervisorOptions}
              onChange={onChange}
              onSubmit={onSearch}
              onCancel={onCancel}
              isLoading={isLoading}
            />
          </CardContainer>
        )}
        <TableAntd
          columns={columns}
          dataSource={accountCategoryList}
          onDelete={onDelete}
          loading={isLoading}
          pagination={pagination}
          onChange={onChange}
        />
      </Space>
    </MainLayout>
  );
};

export default AccountCategoryList;
